import { useEffect, useState } from 'react';
import { useWindowSize } from '@yme/hooks/index';
export const useThumbnailsConfig = (thumbnailsAmount, thumbnailsIndent) => {
    const [currentThumbnailConfig, setCurrentThumbnailConfig] = useState({
        amount: 0,
        indent: '',
    });
    const { isLargeDesktopView, isDesktopView, isTabletView, isMobileView } = useWindowSize();
    useEffect(() => {
        if (isMobileView) {
            setCurrentThumbnailConfig({
                amount: thumbnailsAmount.mobile,
                indent: thumbnailsIndent.mobile,
            });
        }
        if (isTabletView) {
            setCurrentThumbnailConfig({
                amount: thumbnailsAmount.tablet,
                indent: thumbnailsIndent.tablet,
            });
        }
        if (isDesktopView) {
            setCurrentThumbnailConfig({
                amount: thumbnailsAmount.smallDesktop,
                indent: thumbnailsIndent.smallDesktop,
            });
        }
        if (isLargeDesktopView) {
            setCurrentThumbnailConfig({
                amount: thumbnailsAmount.desktop,
                indent: thumbnailsIndent.desktop,
            });
        }
    }, [
        isLargeDesktopView,
        isDesktopView,
        isTabletView,
        isMobileView,
        thumbnailsAmount.desktop,
        thumbnailsAmount.smallDesktop,
        thumbnailsAmount.tablet,
        thumbnailsAmount.mobile,
        thumbnailsIndent.desktop,
        thumbnailsIndent.smallDesktop,
        thumbnailsIndent.tablet,
        thumbnailsIndent.mobile,
    ]);
    return {
        thumbnailConfig: currentThumbnailConfig,
    };
};
